// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Y-D-p","bigColWidth":"Table_bigColWidth__fxaF4","biggerColWidth":"Table_biggerColWidth__1oXbt","row":"Table_row__1mskG","col":"Table_col___78aO"};